import React from "react";
// Import Swiper React components
import { Navigation, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper-bundle.css";

// Images or Logos
import logo1 from "../assets/images/clients/01.jpg";
import logo2 from "../assets/images/clients/02.jpg";
import logo3 from "../assets/images/clients/03.jpg";
import logo4 from "../assets/images/clients/04.jpg";
import logo5 from "../assets/images/clients/05.jpg";
import logo6 from "../assets/images/clients/06.jpg";
import logo7 from "../assets/images/clients/07.jpg";
import logo8 from "../assets/images/clients/08.jpg";

export const data = [
  {
    key: 1,
    image: logo1,
  },
  {
    key: 2,
    image: logo2,
  },
  {
    key: 3,
    image: logo3,
  },
  {
    key: 4,
    image: logo4,
  },
  {
    key: 5,
    image: logo5,
  },
  {
    key: 6,
    image: logo6,
  },
  {
    key: 7,
    image: logo7,
  },
  {
    key: 8,
    image: logo8,
  },
];

// import required modules

function Clients() {
  // SwiperCore.use([Autoplay]);
  return (
    <section className="clients py-5 bg-light" id="clients">
      <div className="clients-slider">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 className="mb-5 text-center fw-bold text-uppercase">
                Our Clients
              </h3>
            </div>
            <div className="col-12">
              <Swiper
                autoplay={{ delay: 4000 }}
                navigation={true}
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                modules={[Navigation, Autoplay]}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 5,
                  },
                }}
                className="mySwiper"
              >
                {data.map((item) => {
                  return (
                    <SwiperSlide key={item.key}>
                      <img
                        src={item.image}
                        alt=""
                        className="img-fluid w-100"
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Clients;
